import { BtnVoltarAtv03 } from "../../components/BtnVoltar";

function Item({ name, isPacked }) {
    let itemContent = name;
    if (isPacked) {
        itemContent = (
            <del>
                {name + " ✓"}
            </del>
        )
    }
    return (
        <li>
            {itemContent}
        </li>
    );
    
}

export default function Atividade16() {
    return(
        <section>
            <h1>Sally Ride's Packing List</h1>
            <ul>
                <Item
                    isPacked={true}
                    name="Space suit"
                />
                <Item
                    isPacked={true}
                    name="Helmet with a golden leaf"
                />
                <Item
                    isPacked={false}
                    name="Photo of Tam"
                />
            </ul>
            <BtnVoltarAtv03 />
        </section>
    );
}